import React from 'react';
import ResetPassword from '../components/ResetPassword';

// The page carries its own public nav now (v2/auth/AuthShell), so the v1 Navbar that used
// to sit above it would be a second header on the same screen.
function LForgetpassword() {
  return <ResetPassword />;
}

export default LForgetpassword;
